import React from 'react'
import JsonData from './Events.json'
import styled from 'styled-components'
import Fade from 'react-reveal/Fade'
import a from '../images/b.jpg'


 function JsonDataDisplay(){
    JsonData.sort((a, b) => new Date(b.date) - new Date(a.date));
    const [past, upcoming] = JsonData.reduce((accum, curr) => {
        if (new Date(curr.date) - new Date() < 0) return [[...accum[0], curr], accum[1]];
        return [accum[0], [...accum[1], curr]];
      }, [[], []]);

      const getName = (name, link) => link ? `<a href="${link}">${name}</a>` : name;
      const getEventsHTML = events => JsonData.length 
        ? JsonData.map(event => `
          <tr>
            <td>${event.date}</td>
            <td style="min-width: 200px">${getName(event.name, event.link)}</td>
            <td style="max-width: 300px">${event.desc}</td>
            <td style="max-width: 200px">${event.loc}</td>
          </tr>
        `).join('') 
        : '<tr><td>TBA</td></tr>';
      const getHTML = JsonData => (`
        <tr>
          <td>Date</td>
          <td>Event</td>
          <td>Description</td>
          <td>Location</td>
        </tr>
      ` + getEventsHTML(JsonData))
    
//       const previousTable = document.querySelector('.previous-events')
//   const pastHTML = getHTML(past)
//   previousTable.innerHTML = pastHTML;

//   const upcomingTable = document.querySelector('.upcoming-events')
//   const upcomingHTML = getHTML(upcoming)
//   upcomingTable.innerHTML = upcomingHTML;
  
    const DisplayData=JsonData.map(
        (info)=>{
            return(
                <tr >
                    <td className='table'>{info.date}</td>
                    <td className='table'>{info.name}</td>
                    <td className='table'>{info.desc}</td>
                    <td className='table'>{info.loc}</td>
                </tr>
            )
        }
    )
 
    return(
        <div>
            <Wrap style={{ backgroundImage: `url(${a})` }}>
			{/* <img className='img' src={learn} /> */}
         <Fade bottom>
				<ItemText>
					<h1 >Upcoming Events</h1>
                     <p>There are no upcoming events at this time. Check back soon!</p>
                     
				</ItemText>

                <ItemText>
                <h1 >Past Events</h1>
                <table >
                <thead>
                    <tr>
                    <th>Date</th>
                    <th>Name</th>
                    <th>Description</th>
                    <th>Mode</th>
                    
                    </tr>
                </thead>
                <tbody>
                 
                    
                    {DisplayData}
                    
                </tbody>
            </table>
				</ItemText>
			
            

            </Fade>
         </Wrap>
             
        </div>
    )
 }
 
 export default JsonDataDisplay;

 const Heading = styled.div`
    font-size : 80px;
    color
`

const Wrap = styled.div `
    min-height:100vh;
    background-color: whitesmoke;
	color:black;
	background-size: cover; /* set size to cover */
	background-position: center; /* center the image */
	background-repeat: no-repeat; /* dont repeat the background */

	display: flex;
	flex-direction: column; /* switch to vertical */
	justify-content: center; /* horizontal alignment */
	align-items: center; /* vertical alignment */

	@media (max-width : 768px){
		flex-direction: column;
	}
`

const ItemText = styled.div `
	padding-top: 15vh;
	text-align: center;
`